import sgMail from '@sendgrid/mail';

// Initialize SendGrid with API key (environment variables loaded by the server)
sgMail.setApiKey(process.env.SENDGRID_API_KEY);

const sendEmail = async ({ to, subject, html, text }) => {
  const msg = {
    to,
      from: 'info@pristinemaint.com', // Your verified sender
    subject,
    text,
    html
  };
  
  try {
    await sgMail.send(msg);
    console.log('✅ Email sent successfully via SendGrid');
    return { success: true };
  } catch (error) {
    console.error('❌ SendGrid error:', error);
    console.error('❌ Error details:', {
      code: error.code,
      message: error.message,
      response: error.response?.body,
      headers: error.response?.headers
    });
    throw error;
  }
};

export { sendEmail };
